import { render } from "./Pricing.vue?vue&type=template&id=f2281f9a&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"

import "./Pricing.vue?vue&type=style&index=0&id=f2281f9a&scoped=true&lang=css"

import exportComponent from "/Users/alexanderwesselburg/Projekte/MyPortal/fewo-in-ahrenshoop_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2281f9a"]])

export default __exports__